import { render, staticRenderFns } from "./SchemaInputCopyPickerModal.vue?vue&type=template&id=24860e19&scoped=true&"
import script from "./SchemaInputCopyPickerModal.vue?vue&type=script&lang=js&"
export * from "./SchemaInputCopyPickerModal.vue?vue&type=script&lang=js&"
import style0 from "./SchemaInputCopyPickerModal.vue?vue&type=style&index=0&id=24860e19&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24860e19",
  null
  
)

export default component.exports